/**
* Custom Select
*/
class customSelect extends HTMLElement {
  constructor() {
    super();
    this.selectContainer = this.querySelector('.custom-dropdown');
    this.select = this.querySelector('ul');
    this.initOption = this.querySelector('.default');
    this.options = this.select.querySelectorAll('li');

    this.options.forEach(option => 
      option.addEventListener('click', this.toggleOptions.bind(this))
    );
    this.initOption.addEventListener('click', this.manageVisibility.bind(this));

    // Close dropdown on outside click
    document.body.addEventListener('click', this.handleOutsideClick.bind(this));
  }

  disconnectedCallback() {
    document.body.removeEventListener('click', this.handleOutsideClick.bind(this));
  }

  /**
   * Toggle custom select option
   * @param event 
   */
  toggleOptions(event) {
    let _this = event.currentTarget;
    const input = _this.querySelector('input');
    if (input?.disabled) return;

    this.options.forEach(option => option.classList.remove('selected'));
    _this.classList.add('selected');
    this.selectContainer.classList.add('selected');
    Utility.toggleElement(this.selectContainer, 'close');
    let option_wrapper = _this.closest('variant-radios') || _this.closest('variant-selects')
    if (option_wrapper) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    setTimeout(() => {
      this.initOption.querySelector('.option_txt').textContent = _this.querySelector('.option_txt').textContent;
    }, 500);
  }

  /**
   * Hide/Show of custom select option
   * @param _event 
   */
  manageVisibility(_event) {
    let isOpen = this.selectContainer.classList.contains('open');
    Utility.toggleElement(this.selectContainer, isOpen ? 'close' : 'open');
  }

  /**
   * Handle clicks outside the custom select to close dropdown
   * @param event 
   */
  handleOutsideClick(event) {
    if (!this.contains(event.target)) {
      Utility.toggleElement(this.selectContainer, 'close');
    }
  }
}

customElements.define('custom-select', customSelect);

/**
* Tab HTML
*/
class customTabs extends HTMLElement {
    constructor() {
      super();

      this.isTouchDevice = 'ontouchstart' in window || navigator.msMaxTouchPoints > 0;
      this.tabLinks = this.querySelectorAll('.tablink');
      this.tabContainers = this.querySelectorAll('.tabcontent');
  
      this.tabLinks.forEach( link => link.addEventListener('click', this.toggleTabs.bind(this)));
      if (this.dataset?.tabOnHover == "true") {
        this.tabLinks.forEach( link => {
          link.addEventListener('mouseover', this.toggleTabs.bind(this));

          this.addEventListener('mouseleave', (e) => {
            e.preventDefault();
            this.closeTab();
          })
        })
      };
      document.addEventListener('overlay:clicked', () => {
        this.closeTab();
      });
    }
  
    /**
     * Escape Key Press to close drawer when focus is within the container
     *
     * @param {event} Event instance
     */
    onKeyUp(event) {
      if(event.code && event.code.toUpperCase() !== 'ESCAPE') return;
    }
  
    /**
     * Toggle Tabs on link click
     *
     * @param {event} Event instance
     */
    toggleTabs(event){
      event.preventDefault();
      const currentTab = event.currentTarget;
      const tabLink = currentTab.querySelector('[data-toggle="tab"]');
      const tabContainer = document.querySelector(tabLink.dataset.tabcontent);
      this.openTab(currentTab, tabContainer)
    }
  
    /**
     * Open Tab Container
     *
     * @param {Node} currentTab Tab Container Open link
     * @param {Node} tabContainer Tab Container to open
     */
    openTab(currentTab, tabContainer) {
      this.tabContainers.forEach(container => {
        container.classList.remove('open');
        setTimeout(() =>{
          container.classList.remove('show');
        }, 100);
        const linkEle = document.querySelector('.tablink a[data-toggle="tab"][data-tabcontent="#'+container.id+'"]');
        if(linkEle){
          linkEle.setAttribute('aria-expanded', false);
          if(linkEle.closest('.tablink')){ linkEle.closest('.tablink').classList.remove('open');}
        }
      });
      currentTab.classList.add('open');

      currentTab.querySelector('[data-toggle="tab"]').setAttribute('aria-expanded', true);
      tabContainer.classList.add('open');
      setTimeout(() =>{
        tabContainer.classList.add('show');
      }, 100);
    }

    closeTab() {
      this.tabContainers.forEach(container => {
        container.classList.remove('open');
        setTimeout(() =>{
          container.classList.remove('show');
        }, 100);
        const linkEle = document.querySelector('.tablink a[data-toggle="tab"][data-tabcontent="#'+container.id+'"]');
        if(linkEle){
          linkEle.setAttribute('aria-expanded', false);
          if(linkEle.closest('.tablink')){ linkEle.closest('.tablink').classList.remove('open');}
        }
      });
    }
}
customElements.define("custom-tabs", customTabs);


// class customTabs extends HTMLElement {
//     constructor() {
//         super();

//         this.isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
//         this.tabLinks = this.querySelectorAll('.tablink');
//         this.tabContainers = this.querySelectorAll('.tabcontent');

//         this.tabLinks.forEach(link => {
//             link.addEventListener('click', (event) => {
//                 event.preventDefault();
//                 this.toggleTabs(event);
//             });

//             // Apply hover only for non-touch devices
//             if (!this.isTouchDevice && this.dataset?.tabOnHover === "true") {
//                 link.addEventListener('mouseover', (event) => {
//                     event.preventDefault();
//                     this.toggleTabs(event);
//                 });

//                 this.addEventListener('mouseleave', (event) => {
//                     event.preventDefault();
//                     this.closeTab();
//                 });
//             }
//         });
//     }

//     /**
//      * Toggle Tabs on link click
//      *
//      * @param {Event} event Event instance
//      */
//     toggleTabs(event) {
//         event.preventDefault();
//         const currentTab = event.currentTarget;
//         const tabLink = currentTab.querySelector('[data-toggle="tab"]');

//         if (!tabLink || !tabLink.dataset.tabcontent) return;
        
//         const tabContainer = document.querySelector(tabLink.dataset.tabcontent);
//         if (!tabContainer) return;

//         this.openTab(currentTab, tabContainer);
//     }

//     /**
//      * Open Tab Container
//      *
//      * @param {Node} currentTab Tab Container Open link
//      * @param {Node} tabContainer Tab Container to open
//      */
//     openTab(currentTab, tabContainer) {
//         this.tabContainers.forEach(container => {
//             container.classList.remove('open');
//             setTimeout(() => {
//                 container.classList.remove('show');
//             }, 100);
//             const linkEle = document.querySelector(`.tablink a[data-toggle="tab"][data-tabcontent="#${container.id}"]`);
//             if (linkEle) {
//                 linkEle.setAttribute('aria-expanded', false);
//                 if (linkEle.closest('.tablink')) {
//                     linkEle.closest('.tablink').classList.remove('open');
//                 }
//             }
//         });

//         currentTab.classList.add('open');
//         currentTab.querySelector('[data-toggle="tab"]').setAttribute('aria-expanded', true);
//         tabContainer.classList.add('open');

//         setTimeout(() => {
//             tabContainer.classList.add('show');
//         }, 100);
//     }

//     /**
//      * Close all open tabs
//      */
//     closeTab() {
//         this.tabContainers.forEach(container => {
//             container.classList.remove('open');
//             setTimeout(() => {
//                 container.classList.remove('show');
//             }, 100);
//             const linkEle = document.querySelector(`.tablink a[data-toggle="tab"][data-tabcontent="#${container.id}"]`);
//             if (linkEle) {
//                 linkEle.setAttribute('aria-expanded', false);
//                 if (linkEle.closest('.tablink')) {
//                     linkEle.closest('.tablink').classList.remove('open');
//                 }
//             }
//         });
//     }
// }
// customElements.define("custom-tabs", customTabs);

/**
  * collaspsible Panel
  *
  * @param {element} element - Collapsible panel element
*/
class collapsiblePanel {
  constructor(element) {
    this.element = element;
    this.toggleBtn = this.element.querySelector('.panel_toggle');
    if(this.toggleBtn) this.toggleBtn.addEventListener('click', this.toggleContent.bind(this));
  }

  /**
   * Toggle Row Content
   * @param {event} event 
  */
  toggleContent(event) {
    event.preventDefault();
    const isOpen = this.element.classList.contains('open');
    isOpen ? this.hideContent() : this.showContent();
  }

  /**
   * Show panel content
   */
   showContent() {
    this.toggleBtn.setAttribute('aria-expanded', true);
    Utility.toggleElement(this.element, 'open');
    Utility.trapFocus(this.element);

    if(this.element.dataset.behaviour == 'single'){
      let siblingBlocks = this.element.parentNode.querySelectorAll('[is="collapsiblePanel"].open');
      siblingBlocks.forEach(element => {
        if(element == this.element){ return; }
        element.querySelector('.panel_toggle').click();
      });
    }
  }

  /**
   * Hide panel content
   */
  hideContent() {
    this.toggleBtn.setAttribute('aria-expanded', false);
    Utility.toggleElement(this.element, 'close');
    Utility.removeTrapFocus(this.element);
  }

  static init() {
    const collapsibleElements = document.querySelectorAll('[is="collapsiblePanel"]');
    collapsibleElements.forEach((ele) => {
      new collapsiblePanel(ele);
    });
  }
}
collapsiblePanel.init();
  
/**
 * Custom form elemnt is create for making dynamic formm submission for hulk app form builder
 */
class customForm extends HTMLElement {
  constructor() {
    super();

    this.formId = this.getAttribute('data-form-id');
    this.form = this.querySelector('form');
    this.toggleFormBtn = this.querySelectorAll('[data-show-form]');
    this.successMessageEle = this.querySelector('[data-success-message]');
    this.submitBtn = this.querySelector('[type="submit"]');
  }

  connectedCallback() {
    this.form.addEventListener('submit', this.onSubmit.bind(this));
    this.toggleFormBtn?.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        if (this.successMessageEle) {
          this.successMessageEle.classList.add('d-none');
        };
        this.form.classList.remove('d-none');
      })
    });

    this.initRelProductPicker();
    this.initCountryPicker();
    this.initWhereBuyPicker();
    this.initRelNetVisitQuestion();

    this.querySelectorAll('input[type="file"]')?.forEach(input => {
      input.addEventListener('change', (e) => {
        const fileInput = e.currentTarget;
        if (fileInput.hasAttribute('data-receipt-file-input')) {
          this.validateReceiptFiles(fileInput, true);
          return;
        }
        let fileNames = Array.from(fileInput.files).map(file => file.name).join(", ");
        if (fileInput.closest('div')?.querySelector('[data-file-name]')) fileInput.closest('div').querySelector('[data-file-name]').innerHTML = fileNames || `<span class="text-decoration-underline" style="padding-right: 2px;">Choose File</span><span>or drop here.</span>`;
      });
    });

    const modalRoot = this.closest('modal-dialog');
    if (modalRoot && modalRoot.id === 'rel-add-product') {
      modalRoot.addEventListener('rel-modal-hidden', () => {
        this.resetRelAddProductFormState();
      });
    }
  }

  resetRelAddProductFormState() {
    if (!this.form) return;
    this.form.reset();

    const productSelect = this.form.querySelector('[data-rel-product-select]');
    const productGidInput = this.form.querySelector('[data-rel-product-gid-input]');
    const productDisplayInput = this.form.querySelector('[data-rel-product-display-input]');
    const productLabel = this.form.querySelector('[data-rel-product-picker-label]');
    const productSearch = this.form.querySelector('[data-rel-product-search]');

    if (productSelect) productSelect.value = '';
    if (productGidInput) productGidInput.value = '';
    if (productDisplayInput) productDisplayInput.value = '';
    if (productLabel) productLabel.textContent = 'Select your REL';
    if (productSearch) productSearch.value = '';

    const whereBuyInput = this.form.querySelector('[data-where-buy-input]');
    const whereBuyLabel = this.form.querySelector('[data-rel-where-buy-picker-label]');
    if (whereBuyInput) whereBuyInput.value = '';
    if (whereBuyLabel) whereBuyLabel.textContent = 'Dealer or Website';
    this.updateRelNetVisitVisibility(null);

    const countrySelect = this.form.querySelector('[data-rel-country-select]');
    const countryLabel = this.form.querySelector('[data-rel-country-picker-label]');
    const countrySearch = this.form.querySelector('[data-rel-country-search]');
    if (countrySelect) countrySelect.value = '';
    if (countryLabel) countryLabel.textContent = 'Select';
    if (countrySearch) countrySearch.value = '';

  }

  /**
   * Validates receipt file input: images only, max size from data-max-size-mb.
   * @param {HTMLInputElement} input - file input with data-receipt-file-input
   * @param {boolean} onChange - if true, clear input and show UI error; if false, only set validity for submit
   * @returns {boolean} true if valid or empty
   */
  validateReceiptFiles(input, onChange = false) {
    const allowedImageTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/heic'];
    const maxBytes = (parseFloat(input.getAttribute('data-max-size-mb')) || 5) * 1024 * 1024;
    const area = input.closest('[data-receipt-upload-area]');
    const nameEl = area?.querySelector('[data-file-name]');
    const errorEl = area?.querySelector('[data-file-error]');
    const defaultLabel = `<span class="text-decoration-underline" style="padding-right: 2px;">Choose File</span><span>or drop here.</span>`;

    const showError = (msg) => {
      input.setCustomValidity(msg);
      input.classList.add('error');
      if (errorEl) {
        errorEl.textContent = msg;
        errorEl.style.display = 'block';
      }
      if (area) area.classList.add('border', 'border-danger', 'rounded');
    };
    const clearError = () => {
      input.setCustomValidity('');
      input.classList.remove('error');
      if (errorEl) {
        errorEl.textContent = '';
        errorEl.style.display = 'none';
      }
      if (area) area.classList.remove('border', 'border-danger', 'rounded');
    };

    if (!input.files || input.files.length === 0) {
      clearError();
      if (nameEl) nameEl.innerHTML = defaultLabel;
      return true;
    }

    for (const file of input.files) {
      const typeOk = allowedImageTypes.includes(file.type);
      if (!typeOk) {
        const msg = 'Please upload only image files (JPEG, PNG, GIF, WebP, or HEIC). Video and other file types are not accepted.';
        showError(msg);
        if (onChange) {
          input.value = '';
          if (nameEl) nameEl.innerHTML = defaultLabel;
        }
        return false;
      }
      if (file.size > maxBytes) {
        const maxMb = Math.round(maxBytes / (1024 * 1024));
        const msg = `"${file.name}" is too large. Maximum size is ${maxMb} MB per file.`;
        showError(msg);
        if (onChange) {
          input.value = '';
          if (nameEl) nameEl.innerHTML = defaultLabel;
        }
        return false;
      }
    }

    clearError();
    if (nameEl) nameEl.innerHTML = Array.from(input.files).map(f => f.name).join(', ');
    return true;
  }

  initRelProductPicker() {
    const pickerRoot = this.querySelector('[data-rel-product-picker]');
    const selectEl = this.querySelector('[data-rel-product-select]');
    const productGidInput = this.querySelector('[data-rel-product-gid-input]');
    const productDisplayInput = this.querySelector('[data-rel-product-display-input]');
    if (!pickerRoot || !selectEl) return;

    const toggleBtn = pickerRoot.querySelector('[data-rel-product-picker-toggle]');
    const panel = pickerRoot.querySelector('[data-rel-product-picker-panel]');
    const labelEl = pickerRoot.querySelector('[data-rel-product-picker-label]');
    const searchInput = pickerRoot.querySelector('[data-rel-product-search]');
    const listRoot = pickerRoot.querySelector('[data-rel-product-list]');
    const clearBtn = pickerRoot.querySelector('[data-rel-product-search-clear]');
    if (!toggleBtn || !panel || !labelEl || !searchInput || !listRoot) return;

    const initialLabel = labelEl.textContent.trim();

    const options = Array.from(selectEl.options).filter(opt => opt.value && opt.value !== '');

    const parsedOptions = options.map(opt => {
      const fullLabel = opt.textContent.trim();
      const parts = fullLabel.split(' - ').map(p => p.trim()).filter(Boolean);
      const optionGid = (opt.dataset.productGid || '').trim();
      const valueGid = (opt.value || '').trim().startsWith('gid://shopify/Product/') ? (opt.value || '').trim() : '';
      const optionSource = (opt.dataset.relSource || '').trim();
      return {
        value: opt.value,
        fullLabel,
        parts,
        productGid: optionGid || valueGid || '',
        optionSource
      };
    });

    let currentLevel = 0;      // 0 = product, 1 = variant, 2 = finish, etc.
    let currentPath = [];      // selected labels for previous levels

    listRoot.style.transition = 'opacity 150ms ease-out, transform 150ms ease-out';
    listRoot.style.opacity = '1';
    listRoot.style.transform = 'translateY(0)';
    listRoot.style.maxHeight = 'min(320px, 60vh)';
    listRoot.style.overflowY = 'auto';
    listRoot.style.webkitOverflowScrolling = 'touch';

    const getChoicesForLevel = (level, pathParts) => {
      const choicesMap = new Map();

      parsedOptions.forEach(opt => {
        // Ensure this option matches the already chosen path
        for (let i = 0; i < pathParts.length; i += 1) {
          if (opt.parts[i] !== pathParts[i]) return;
        }

        const partLabel = opt.parts[level] || opt.parts[opt.parts.length - 1];
        if (!choicesMap.has(partLabel)) {
          choicesMap.set(partLabel, { label: partLabel, options: [] });
        }
        choicesMap.get(partLabel).options.push(opt);
      });

      return Array.from(choicesMap.values());
    };

    let optionIndex = 0;
    const render = (query = '') => {
      const q = query.trim().toLowerCase();
      const level = currentLevel;

      listRoot.style.opacity = '0';
      listRoot.style.transform = 'translateY(2px)';

      window.requestAnimationFrame(() => {
        listRoot.innerHTML = '';
        optionIndex = 0;

        // Breadcrumb / heading
        const heading = document.createElement('div');
        // When drilling into product levels we add a "Back" button, which increases heading height;
        // reduce bottom margin to keep spacing consistent with the initial level.
        heading.className = `d-flex align-items-center justify-content-between ${level > 0 ? 'mb-0' : 'mb-2'}`;

        const pathLabel = document.createElement('p');
        pathLabel.className = 'fw-medium mb-0';
        pathLabel.textContent = currentPath.length ? currentPath.join(' • ') : 'Select your REL';
        heading.appendChild(pathLabel);

        if (currentLevel > 0) {
          const backBtn = document.createElement('button');
          backBtn.type = 'button';
          backBtn.className = 'btn btn-link px-0 py-0 fw-normal rel-product-picker__back';
          backBtn.textContent = 'Back';
          backBtn.addEventListener('click', () => {
            currentPath.pop();
            currentLevel = Math.max(0, currentLevel - 1);
            searchInput.value = '';
            render('');
          });
          heading.appendChild(backBtn);
        }

        listRoot.appendChild(heading);

        let choices = getChoicesForLevel(level, currentPath);
        if (q) {
          choices = choices.filter(choice => choice.label.toLowerCase().includes(q));
        }

        const ul = document.createElement('ul');
        ul.className = 'list-unstyled mb-0';

        choices.forEach(choice => {
          const li = document.createElement('li');
          li.className = 'mb-1 rel-product-picker__option';
          li.style.animationDelay = `${60 + optionIndex * 35}ms`;
          optionIndex += 1;

          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'btn btn-light w-100 text-start';
          const labelSpan = document.createElement('span');
          labelSpan.className = 'rel-product-picker__option-label';
          labelSpan.textContent = choice.label;
          btn.appendChild(labelSpan);

          btn.addEventListener('click', () => {
            const nextLevel = level + 1;
            const nextPath = currentPath.slice(0, level);
            nextPath[level] = choice.label;

            const matchedOptions = choice.options;
            const hasNextLevel = matchedOptions.some(o => o.parts.length > nextLevel);
            const nextChoices = hasNextLevel ? getChoicesForLevel(nextLevel, nextPath) : [];

            if (hasNextLevel && nextChoices.length > 0) {
              // Move to next step – show building product string in search input
              currentLevel = nextLevel;
              currentPath = nextPath;
              searchInput.value = nextPath.join(' - ');
              render('');
            } else {
              // We have a final option – prefer exact fullLabel match to path (avoids wrong GID when multiple options share early segments).
              const pathKey = nextPath.join(' - ');
              const chosen = matchedOptions.find((o) => o.fullLabel === pathKey) || matchedOptions[0];
              if (!chosen) return;
              selectEl.value = chosen.value;
              const resolvedGid =
                chosen.productGid ||
                (String(chosen.value || '').trim().startsWith('gid://shopify/Product/') ? String(chosen.value).trim() : '');
              if (productGidInput) productGidInput.value = resolvedGid;
              if (productDisplayInput) productDisplayInput.value = chosen.fullLabel;
              labelEl.textContent = chosen.fullLabel;
              searchInput.value = chosen.fullLabel;

              // Reset the stepper for the next time the panel opens
              currentLevel = 0;
              currentPath = [];
              closePanel();
            }
          });

          li.appendChild(btn);
          ul.appendChild(li);
        });

        listRoot.appendChild(ul);

        window.requestAnimationFrame(() => {
          listRoot.style.opacity = '1';
          listRoot.style.transform = 'translateY(0)';
        });
      });
    };

    const closePanel = () => {
      if (!panel.classList.contains('rel-product-picker__panel--open')) return;
      panel.classList.remove('rel-product-picker__panel--open');
      toggleBtn.setAttribute('aria-expanded', 'false');
      panel.setAttribute('aria-hidden', 'true');
      panel.addEventListener('transitionend', function onClose(event) {
        if (event.propertyName !== 'opacity') return;
        if (panel.classList.contains('rel-product-picker__panel--open')) return;
        panel.removeEventListener('transitionend', onClose);
        panel.hidden = true;
      });
    };

    const openPanel = () => {
      if (!panel.hidden && panel.classList.contains('rel-product-picker__panel--open')) return;
      panel.hidden = false;
      panel.setAttribute('aria-hidden', 'false');
      toggleBtn.setAttribute('aria-expanded', 'true');

      // Always start at the first step (product search)
      currentLevel = 0;
      currentPath = [];

      const selectedValue = selectEl.value;
      if (selectedValue) {
        const selected = parsedOptions.find(o => o.value === selectedValue);
        const label = selected ? selected.fullLabel : labelEl.textContent.trim();
        if (label) {
          labelEl.textContent = label;
          searchInput.value = label;
        } else {
          searchInput.value = '';
        }
      } else {
        searchInput.value = '';
      }

      render(searchInput.value);

      window.requestAnimationFrame(() => {
        panel.classList.add('rel-product-picker__panel--open');
      });
      searchInput.focus();
      searchInput.select();
    };

    toggleBtn.addEventListener('click', () => {
      const isOpen = panel.classList.contains('rel-product-picker__panel--open') || !panel.hidden;
      if (isOpen) {
        closePanel();
      } else {
        openPanel();
      }
    });

    searchInput.addEventListener('input', (e) => {
      render(e.target.value);
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', () => {
        // Clear active selection and reset to the first step
        selectEl.value = '';
        if (productGidInput) productGidInput.value = '';
        if (productDisplayInput) productDisplayInput.value = '';
        labelEl.textContent = initialLabel || 'Select your REL';
        searchInput.value = '';
        currentLevel = 0;
        currentPath = [];
        render('');
        searchInput.focus();
      });
    }

    document.addEventListener('click', (event) => {
      if (!pickerRoot.contains(event.target)) {
        closePanel();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closePanel();
      }
    });

    if (selectEl.value) {
      const currentOpt = options.find(o => o.value === selectEl.value);
      if (currentOpt) {
        const label = currentOpt.textContent.trim();
        const dg = (currentOpt.dataset.productGid || '').trim();
        const v = (currentOpt.value || '').trim();
        const resolved = dg.startsWith('gid://shopify/Product/') ? dg : v.startsWith('gid://shopify/Product/') ? v : '';
        if (productGidInput) productGidInput.value = resolved;
        if (productDisplayInput) productDisplayInput.value = label;
        labelEl.textContent = label;
        searchInput.value = label;
      }
    }
  }

  initCountryPicker() {
    const pickerRoot = this.querySelector('[data-rel-country-picker]');
    const selectEl = this.querySelector('[data-rel-country-select]');
    if (!pickerRoot || !selectEl) return;

    const toggleBtn = pickerRoot.querySelector('[data-rel-country-picker-toggle]');
    const panel = pickerRoot.querySelector('[data-rel-country-picker-panel]');
    const labelEl = pickerRoot.querySelector('[data-rel-country-picker-label]');
    const searchInput = pickerRoot.querySelector('[data-rel-country-search]');
    const listRoot = pickerRoot.querySelector('[data-rel-country-list]');
    const clearBtn = pickerRoot.querySelector('[data-rel-country-search-clear]');
    if (!toggleBtn || !panel || !labelEl || !searchInput || !listRoot) return;

    const initialLabel = labelEl.textContent.trim();
    const options = Array.from(selectEl.options).filter(opt => {
      if (!opt.value || opt.value === '') return false;
      const text = opt.textContent.trim();
      if (text === '---' || text === '—' || text === '–') return false;
      return true;
    });

    listRoot.style.transition = 'opacity 150ms ease-out, transform 150ms ease-out';
    listRoot.style.opacity = '1';
    listRoot.style.transform = 'translateY(0)';
    listRoot.style.maxHeight = 'min(320px, 60vh)';
    listRoot.style.overflowY = 'auto';
    listRoot.style.webkitOverflowScrolling = 'touch';

    let optionIndex = 0;
    const render = (query = '') => {
      const q = query.trim().toLowerCase();

      listRoot.style.opacity = '0';
      listRoot.style.transform = 'translateY(2px)';

      window.requestAnimationFrame(() => {
        listRoot.innerHTML = '';
        optionIndex = 0;

        const filtered = options.filter(opt => {
          if (!q) return true;
          return opt.textContent.trim().toLowerCase().includes(q);
        });

        const ul = document.createElement('ul');
        ul.className = 'list-unstyled mb-0';

        filtered.forEach(opt => {
          const li = document.createElement('li');
          li.className = 'mb-1 rel-country-picker__option';
          li.style.animationDelay = `${60 + optionIndex * 35}ms`;
          li.id = `country-opt-${opt.value}`;
          optionIndex += 1;

          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'btn btn-light w-100 text-start';
          const labelSpan = document.createElement('span');
          labelSpan.className = 'rel-country-picker__option-label';
          labelSpan.textContent = opt.textContent.trim();
          btn.appendChild(labelSpan);

          btn.addEventListener('click', () => {
            selectEl.value = opt.value;
            labelEl.textContent = opt.textContent.trim();
            searchInput.value = opt.textContent.trim();
            closePanel();
          });

          li.appendChild(btn);
          ul.appendChild(li);
        });

        listRoot.appendChild(ul);

        window.requestAnimationFrame(() => {
          listRoot.style.opacity = '1';
          listRoot.style.transform = 'translateY(0)';
        });
      });
    };

    const closePanel = () => {
      if (!panel.classList.contains('rel-country-picker__panel--open')) return;
      panel.classList.remove('rel-country-picker__panel--open');
      toggleBtn.setAttribute('aria-expanded', 'false');
      panel.setAttribute('aria-hidden', 'true');
      panel.addEventListener('transitionend', function onClose(event) {
        if (event.propertyName !== 'opacity') return;
        if (panel.classList.contains('rel-country-picker__panel--open')) return;
        panel.removeEventListener('transitionend', onClose);
        panel.hidden = true;
      });
    };

    const openPanel = () => {
      if (!panel.hidden && panel.classList.contains('rel-country-picker__panel--open')) return;
      panel.hidden = false;
      panel.setAttribute('aria-hidden', 'false');
      toggleBtn.setAttribute('aria-expanded', 'true');

      if (selectEl.value) {
        const selected = options.find(o => o.value === selectEl.value);
        searchInput.value = selected ? selected.textContent.trim() : '';
      } else {
        searchInput.value = '';
      }
      render(searchInput.value);

      window.requestAnimationFrame(() => {
        panel.classList.add('rel-country-picker__panel--open');
      });
      searchInput.focus();
      searchInput.select();
    };

    toggleBtn.addEventListener('click', () => {
      const isOpen = panel.classList.contains('rel-country-picker__panel--open') || !panel.hidden;
      if (isOpen) {
        closePanel();
      } else {
        openPanel();
      }
    });

    searchInput.addEventListener('input', (e) => {
      render(e.target.value);
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', () => {
        selectEl.value = '';
        labelEl.textContent = initialLabel || 'Select';
        searchInput.value = '';
        render('');
        searchInput.focus();
      });
    }

    document.addEventListener('click', (event) => {
      if (!pickerRoot.contains(event.target)) {
        closePanel();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closePanel();
      }
    });

    if (selectEl.value) {
      const currentOpt = options.find(o => o.value === selectEl.value);
      if (currentOpt) {
        const label = currentOpt.textContent.trim();
        labelEl.textContent = label;
        searchInput.value = label;
      }
    }
  }

  initWhereBuyPicker() {
    const pickerRoot = this.querySelector('[data-rel-where-buy-picker]');
    const hiddenInput = this.querySelector('[data-where-buy-input]');
    if (!pickerRoot || !hiddenInput) return;

    const toggleBtn = pickerRoot.querySelector('[data-rel-where-buy-picker-toggle]');
    const panel = pickerRoot.querySelector('[data-rel-where-buy-picker-panel]');
    const labelEl = pickerRoot.querySelector('[data-rel-where-buy-picker-label]');
    const listEl = pickerRoot.querySelector('[data-rel-where-buy-list]');
    if (!toggleBtn || !panel || !labelEl || !listEl) return;

    const t = (key) => pickerRoot.dataset[key] || key;
    const labels = {
      website: t('labelWebsite'),
      relNet: t('labelRelNet'),
      dealer: t('labelDealer'),
      other: t('labelOther'),
      enterDealer: t('labelEnterDealer'),
      pleaseSpecify: t('labelPleaseSpecify'),
      done: t('labelDone'),
      placeholder: t('labelPlaceholder')
    };

    const initialLabel = labels.placeholder;
    let step = 'choice';
    let chosenCategory = null;

    const setValue = (value, displayText, category = null) => {
      hiddenInput.value = value;
      hiddenInput.setCustomValidity('');
      labelEl.textContent = displayText || value || initialLabel;
      this.updateRelNetVisitVisibility(category || this.getWhereBuyCategory(value));
    };

    const closePanel = () => {
      if (!panel.classList.contains('rel-where-buy-picker__panel--open')) return;
      toggleBtn.focus();
      panel.classList.remove('rel-where-buy-picker__panel--open');
      toggleBtn.setAttribute('aria-expanded', 'false');
      panel.setAttribute('aria-hidden', 'true');
      panel.addEventListener('transitionend', function onClose(event) {
        if (event.propertyName !== 'opacity') return;
        if (panel.classList.contains('rel-where-buy-picker__panel--open')) return;
        panel.removeEventListener('transitionend', onClose);
        panel.hidden = true;
      });
    };

    const openPanel = () => {
      if (!panel.hidden && panel.classList.contains('rel-where-buy-picker__panel--open')) return;
      panel.hidden = false;
      panel.setAttribute('aria-hidden', 'false');
      toggleBtn.setAttribute('aria-expanded', 'true');
      step = 'choice';
      chosenCategory = null;
      render();
      window.requestAnimationFrame(() => {
        panel.classList.add('rel-where-buy-picker__panel--open');
      });
    };

    const choiceOpts = [
      { id: 'website', label: labels.website },
      { id: 'dealer', label: labels.dealer },
      { id: 'other', label: labels.other }
    ];

    const render = () => {
      listEl.innerHTML = '';
      listEl.style.transition = 'opacity 150ms ease-out, transform 150ms ease-out';
      listEl.style.opacity = '1';
      listEl.style.transform = 'translateY(0)';
      listEl.style.maxHeight = 'min(320px, 60vh)';
      listEl.style.overflowY = 'auto';
      listEl.style.webkitOverflowScrolling = 'touch';

      if (step === 'choice') {
        const ul = document.createElement('ul');
        ul.className = 'list-unstyled mb-0';

        choiceOpts.forEach((opt, i) => {
          const li = document.createElement('li');
          li.className = 'mb-1 rel-where-buy-picker__option';
          li.style.animationDelay = `${60 + i * 35}ms`;

          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'btn btn-light w-100 text-start';
          const span = document.createElement('span');
          span.className = 'rel-where-buy-picker__option-label';
          span.textContent = opt.label;
          btn.appendChild(span);

          btn.addEventListener('click', (e) => {
            e.stopPropagation();
            chosenCategory = opt.id;
            if (opt.id === 'website') {
              step = 'website';
              render();
            } else if (opt.id === 'dealer') {
              step = 'dealer';
              render();
            } else {
              step = 'other';
              render();
            }
          });

          li.appendChild(btn);
          ul.appendChild(li);
        });

        listEl.appendChild(ul);
      } else if (step === 'website') {
        const ul = document.createElement('ul');
        ul.className = 'list-unstyled mb-0';

        const backBtn = document.createElement('button');
        backBtn.type = 'button';
        backBtn.className = 'btn btn-link px-0 py-0 fw-normal rel-where-buy-picker__back mb-2';
        backBtn.textContent = 'Back';
        backBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          step = 'choice';
          chosenCategory = null;
          render();
        });
        listEl.appendChild(backBtn);

        const li = document.createElement('li');
        li.className = 'mb-1 rel-where-buy-picker__option';

        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'btn btn-light w-100 text-start';
        const span = document.createElement('span');
        span.className = 'rel-where-buy-picker__option-label';
        span.textContent = labels.relNet;
        btn.appendChild(span);

        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          setValue('REL.net', labels.relNet, 'website');
          closePanel();
        });

        li.appendChild(btn);
        ul.appendChild(li);
        listEl.appendChild(ul);
      } else if (step === 'dealer' || step === 'other') {
        const isDealer = step === 'dealer';
        const placeholder = isDealer ? labels.enterDealer : labels.pleaseSpecify;

        const backBtn = document.createElement('button');
        backBtn.type = 'button';
        backBtn.className = 'btn btn-link px-0 py-0 fw-normal rel-where-buy-picker__back mb-2';
        backBtn.textContent = 'Back';
        backBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          step = 'choice';
          chosenCategory = null;
          render();
        });
        listEl.appendChild(backBtn);

        const input = document.createElement('input');
        input.type = 'text';
        input.className = 'form-control mb-3 bg-secondary-3 border-0 fw-normal';
        input.style.minHeight = '40px';
        input.style.height = '40px';
        input.style.padding = '0 0.75rem';
        input.style.borderRadius = 'var(--bs-border-radius-input, 6px)';
        input.placeholder = placeholder;
        input.setAttribute('autocomplete', 'off');
        const submitInput = () => {
          const val = input.value.trim();
          if (!val) {
            input.setCustomValidity(isDealer ? labels.enterDealer : labels.pleaseSpecify);
            input.reportValidity();
            return;
          }
          const prefix = isDealer ? 'Dealer: ' : 'Other: ';
          const fullVal = prefix + val;
          setValue(fullVal, fullVal, isDealer ? 'dealer' : 'other');
          closePanel();
        };
        input.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            submitInput();
          }
        });
        listEl.appendChild(input);

        const doneWrapper = document.createElement('div');
        doneWrapper.className = 'position-relative overflow-hidden d-inline-flex rounded-4';
        const doneBtn = document.createElement('button');
        doneBtn.type = 'button';
        doneBtn.className = 'btn btn-primary';
        doneBtn.textContent = labels.done;
        doneBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          submitInput();
        });
        doneWrapper.appendChild(doneBtn);
        listEl.appendChild(doneWrapper);

        window.requestAnimationFrame(() => input.focus());
      }
    };

    toggleBtn.addEventListener('click', () => {
      const isOpen = panel.classList.contains('rel-where-buy-picker__panel--open') || !panel.hidden;
      if (isOpen) {
        closePanel();
      } else {
        openPanel();
      }
    });

    document.addEventListener('click', (event) => {
      if (!pickerRoot.contains(event.target)) {
        closePanel();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closePanel();
      }
    });

    if (hiddenInput.value) {
      labelEl.textContent = hiddenInput.value;
      this.updateRelNetVisitVisibility(this.getWhereBuyCategory(hiddenInput.value));
    }
  }

  getWhereBuyCategory(value) {
    if (!value) return null;
    const normalizedValue = value.trim().toLowerCase();
    if (normalizedValue === 'rel.net') return 'website';
    if (normalizedValue.startsWith('dealer:')) return 'dealer';
    if (normalizedValue.startsWith('other:')) return 'other';
    return null;
  }

  initRelNetVisitQuestion() {
    this.updateRelNetVisitVisibility(this.getWhereBuyCategory(this.form.querySelector('[data-where-buy-input]')?.value));
  }

  updateRelNetVisitVisibility(whereBuyCategory) {
    const relNetVisitQuestion = this.form.querySelector('[data-relnet-visit-question]');
    const relNetVisitInputs = this.form.querySelectorAll('[data-relnet-visit-input]');
    if (!relNetVisitQuestion || !relNetVisitInputs.length) return;

    const shouldShow = whereBuyCategory === 'dealer' || whereBuyCategory === 'other';
    relNetVisitQuestion.hidden = !shouldShow;
    if (shouldShow) {
      relNetVisitQuestion.style.removeProperty('display');
    } else {
      relNetVisitQuestion.style.setProperty('display', 'none', 'important');
    }

    relNetVisitInputs.forEach((input) => {
      input.required = shouldShow;
      if (!shouldShow) {
        input.checked = false;
        input.setCustomValidity('');
      }
    });
  }

  validateForm() {
    let isValid = true;
    const invalidFields = [];

    this.form.querySelectorAll('input, textarea, select').forEach(input => {
        if (input.type === 'file' && input.hasAttribute('data-receipt-file-input')) {
          if (!this.validateReceiptFiles(input, false)) {
            isValid = false;
            invalidFields.push({
              name: input.name || '',
              type: input.type,
              reason: 'file_validation_failed'
            });
            input.reportValidity();
          }
          return;
        }
        if (input.hasAttribute('required')) {
            let isEmpty = !input.value.trim();

            if ((input.type === 'radio' || input.type === 'checkbox') && 
                !this.form.querySelector(`input[name="${input.name}"]:checked`)) {
                isValid = false;
                invalidFields.push({
                  name: input.name || '',
                  type: input.type,
                  reason: 'missing_radio_or_checkbox_selection'
                });
                input.classList.add('error');
                input.setCustomValidity('Please select an option');
            } else if (input.type === 'email') {
                let emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailPattern.test(input.value.trim())) {
                    isValid = false;
                    invalidFields.push({
                      name: input.name || '',
                      type: input.type,
                      reason: 'invalid_email'
                    });
                    input.classList.add('error');
                    input.setCustomValidity('Please enter a valid email address');
                } else {
                    input.classList.remove('error');
                    input.setCustomValidity('');
                }
            } else if (input.type !== 'radio' && input.type !== 'checkbox' && isEmpty) {
                isValid = false;
                invalidFields.push({
                  name: input.name || '',
                  type: input.type,
                  reason: 'required_field_empty'
                });
                input.classList.add('error');
                input.setCustomValidity('This field is required');
            } else {
                input.classList.remove('error');
                input.setCustomValidity('');
            }
            
            input.reportValidity(); // Show the validation message
        }
    });    
    return isValid;
  }

  /**
   * Collects form data and sends to Zapier webhook.
   * Form field keys (e.g. "When did you buy REL?") must match input `name` attributes in Liquid.
   * If you change locale strings in templates.my-rel.form, update the getVal() keys below to match.
   */
  async getForm() {
    try {
    const zapierWebhookUrl = this.getAttribute('data-zapier-webhook-url');
    const hasZapierUrl = zapierWebhookUrl && zapierWebhookUrl.trim();

    let formData = { formResponse: {} };
    let fileUploadPromises = [];

    this.form.querySelectorAll('input, textarea, select').forEach((input) => {
        if (input.type === 'file' && input.files.length > 0) {
            // Hulk file upload commented out for testing – uncomment to restore
            // let fileUploadPromise = this.uploadFile(input).then(data => {
            //     formData.formResponse[input.name] = data;
            // });
            // fileUploadPromises.push(fileUploadPromise);
            formData.formResponse[input.name] = {
                _comment: 'Hulk upload disabled for testing',
                file_count: input.files.length,
                file_names: Array.from(input.files).map((f) => f.name)
            };
        } else if (input.type === 'radio' || input.type === 'checkbox') {
            if (input.checked) {
                if (!formData.formResponse[input.name]) {
                    formData.formResponse[input.name] = input.type === 'checkbox' ? [] : '';
                }
                if (input.type === 'checkbox') {
                    formData.formResponse[input.name].push(input.value);
                } else {
                    formData.formResponse[input.name] = input.value;
                }
            }
        } else {
            formData.formResponse[input.name] = input.value;
        }
    });

    // await Promise.all(fileUploadPromises); // Hulk – uncomment to restore

    const fileCount = this.form.querySelectorAll('input[type="file"]')[0]?.files?.length ?? 0;
    try {
            const r = formData.formResponse;
            /** Get first matching value from form by key(s). Keys must match form input `name` attributes. */
            const getVal = (keys) => { for (const k of keys) if (r[k] !== undefined && r[k] !== null && typeof r[k] === 'string') return r[k].trim(); return ''; };

            /* ─── Date fields: sourced from form ──────────────────────────────────────────────────── */
            const purchaseDateStr = getVal(['When did you buy REL?']);  /* Input name from Liquid */
            const purchaseNewOrUsed = getVal(['How did you buy REL?']);  /* "New" or "Used" */

            /**
             * Add days to an ISO date string (YYYY-MM-DD). Returns null if date invalid.
             * Used for: home_trial_expiration_date (purchase + 30 days).
             */
            const addDays = (dateStr, days) => {
                const d = new Date(dateStr);
                if (isNaN(d.getTime())) return null;
                d.setDate(d.getDate() + days);
                return d.toISOString().slice(0, 10);
            };

            /**
             * Add years to an ISO date string (YYYY-MM-DD). Returns null if date invalid.
             * Used for: warranty_expiration_date (purchase + 3 years, New items only).
             */
            const addYears = (dateStr, years) => {
                const d = new Date(dateStr);
                if (isNaN(d.getTime())) return null;
                d.setFullYear(d.getFullYear() + years);
                return d.toISOString().slice(0, 10);
            };

            /* ─── Product fields ─────────────────────────────────────────────────────────────────── */
            const displayNameRaw = getVal(['Product Name']);
            const explicitProductGid = getVal(['Product GID']);
            const explicitDisplayName = getVal(['Product Display Name']);
            const productSelect = this.form.querySelector('select[name="Product Name"]');
            const selectedOpt = productSelect?.selectedOptions?.[0];
            const selectedOptionText = explicitDisplayName || selectedOpt?.textContent?.trim() || '';
            const selectedOptionValue = productSelect?.value?.trim() || '';
            const isProductGid = displayNameRaw.startsWith('gid://shopify/Product/');
            const displayName = isProductGid ? selectedOptionText : displayNameRaw;

            const gidFromOption = (opt) => {
                if (!opt) return '';
                const fromData = (opt.getAttribute('data-product-gid') || '').trim();
                if (fromData.startsWith('gid://shopify/Product/')) return fromData;
                const v = (opt.value || '').trim();
                if (v.startsWith('gid://shopify/Product/')) return v;
                return '';
            };

            const labelToGidMap = new Map();
            if (productSelect) {
                productSelect.querySelectorAll('option').forEach((opt) => {
                    const label = opt.textContent.trim();
                    if (!label) return;
                    const g = gidFromOption(opt);
                    if (g && !labelToGidMap.has(label)) labelToGidMap.set(label, g);
                });
            }

            let productGid = '';
            let productGidSource = 'unresolved';
            if (explicitProductGid && explicitProductGid.startsWith('gid://shopify/Product/')) {
                productGid = explicitProductGid;
                productGidSource = 'explicitProductGid';
            } else if (isProductGid) {
                productGid = displayNameRaw;
                productGidSource = 'displayNameRawIsProductGid';
            } else if (selectedOptionValue.startsWith('gid://shopify/Product/')) {
                productGid = selectedOptionValue;
                productGidSource = 'selectedOptionValue';
            } else {
                /* data-variant-mapping: "DisplayName##ProductGid" pairs, newline-separated. From section settings (custom list). */
                const mappingRaw = this.getAttribute('data-variant-mapping');
                if (mappingRaw) {
                    const map = {};
                    mappingRaw.split('__NL__').forEach((line) => {
                        const idx = line.indexOf('##');
                        if (idx !== -1) {
                            const key = line.slice(0, idx).trim();
                            const val = line.slice(idx + 2).trim();
                            if (key && val) map[key] = val;
                        }
                    });
                    productGid = map[displayNameRaw] || map[selectedOptionText] || map[displayName] || '';
                    if (productGid) productGidSource = 'variantMapping';
                }
            }

            if (!productGid) {
              productGid = gidFromOption(selectedOpt);
              if (productGid) productGidSource = 'gidFromSelectedOption';
            }
            if (!productGid && displayName) {
              productGid = labelToGidMap.get(displayName) || '';
              if (productGid) productGidSource = 'labelToGidMap_displayName';
            }
            if (!productGid && selectedOptionText) {
              productGid = labelToGidMap.get(selectedOptionText) || '';
              if (productGid) productGidSource = 'labelToGidMap_selectedOptionText';
            }
            if (!productGid && displayNameRaw) {
              productGid = labelToGidMap.get(displayNameRaw) || '';
              if (productGid) productGidSource = 'labelToGidMap_displayNameRaw';
            }

            const productGidInput = this.form.querySelector('[data-rel-product-gid-input]');
            if (productGid && productGidInput && !productGidInput.value.trim().startsWith('gid://shopify/Product/')) {
                productGidInput.value = productGid;
            }
            if (!productGid) {
              const productPickerToggle = this.form.querySelector('[data-rel-product-picker-toggle]');
              const msg = 'Unable to map this product to a valid product record. Please choose another option.';
              if (productSelect) {
                productSelect.setCustomValidity(msg);
                productSelect.reportValidity();
              }
              if (productPickerToggle) {
                productPickerToggle.setAttribute('aria-invalid', 'true');
                productPickerToggle.setAttribute('title', msg);
              }
              throw new Error('Unresolved product GID');
            } else if (productSelect) {
              productSelect.setCustomValidity('');
            }
            /**
             * Zapier webhook payload. Field names here must match what Zapier expects.
             * To change date logic: edit home_trial_expiration_date / warranty_expiration_date below.
             * To add/remove fields: update this object and ensure the form has a matching input `name`.
             */
            const zapierPayload = {
                shop_domain: (this.getAttribute('data-shop-domain') || '').trim() || null,
                customer_identifier: getVal(["Customer's Email"]),
                serial_number: getVal(['Serial Number']),
                display_name: displayName,
                product: productGid || null,
                purchase_date: purchaseDateStr || null,
                /* Home trial: purchase date + 30 days. Change 30 to adjust trial length. */
                home_trial_expiration_date: purchaseDateStr ? addDays(purchaseDateStr, 30) : null,
                warranty_approved_admin_only: false,
                /* Warranty: purchase + 3 years, only for "New". Change 3 for different warranty period. Used items get null. */
                warranty_expiration_date: purchaseDateStr && purchaseNewOrUsed === 'New' ? addYears(purchaseDateStr, 3) : null,
                dealer_or_website_of_purchase: getVal(['Where did you buy REL?']),
                country: getVal(['Country Of Purchase']),
                purchase_new_or_used: purchaseNewOrUsed || null
            };
            const multipartBody = new FormData();
            multipartBody.append('data', JSON.stringify(zapierPayload));
            const multipartFileKeys = [];
            this.form.querySelectorAll('input[type="file"]').forEach((input) => {
                for (const file of input.files) {
                    multipartBody.append(input.name, file);
                    multipartFileKeys.push(input.name);
                    // Mirror receipt uploads to a stable key for Zapier file parsing/mapping.
                    if (input.hasAttribute('data-receipt-file-input')) {
                        multipartBody.append('receipt', file);
                        multipartFileKeys.push('receipt');
                    }
                }
            });
            if (!hasZapierUrl) {
              console.warn('[Add product form] Webhook URL is not set; submission skipped.');
            } else {
              await fetch(zapierWebhookUrl.trim(), {
                  method: 'POST',
                  body: multipartBody
              });
            }
        } catch (err) {
            console.error('Zapier webhook error:', err);
    }

    // Hulk form submit commented out for testing – uncomment to restore
    // try {
    //     let response = await fetch(`https://formbuilder.hulkapps.com/forms/create_response/${this.formId}`, {
    //         method: 'POST',
    //         headers: {
    //             "Content-Type": "application/json",
    //             "X-Form-Access-Token": "8f446f9dd5ff1183"
    //         },
    //         body: JSON.stringify(formData)
    //     });
    //     if (!response.ok) {
    //         throw new Error(`HTTP error! Status: ${response.status}`);
    //     }
    //     let data = await response.json();
    //     if (this.successMessageEle) {
    //         this.successMessageEle.classList.remove('d-none');
    //         this.form.classList.add('d-none');
    //         this.submitBtn.classList.remove('loading');
    //     }
    // } catch (error) {
    //     console.error("Form submission error:", error);
    // }
    } catch (err) {
      console.error('getForm error:', err);
    } finally {
      if (this.successMessageEle) {
        this.successMessageEle.classList.remove('d-none');
      }
      this.form?.classList.add('d-none');
      this.submitBtn?.classList.remove('loading');
    }
}

  async uploadFile(field) {
      let files = [];

      for (const file of field.files) {
          let individualFormData = new FormData();
          individualFormData.append("file_data", file);

          try {
              let response = await fetch(`https://formbuilder.hulkapps.com/forms/file_upload/${this.formId}`, {
                  method: 'POST',
                  headers: { "X-Form-Access-Token": "8f446f9dd5ff1183" },
                  body: individualFormData,
                  redirect: 'follow'
              });

              let imageResp = await response.json();

              if (!response.ok || imageResp.error) {
                  throw new Error(imageResp.error || 'File upload failed');
              }

              files.push({
                  url: imageResp.response.url,
                  type: "file",
                  id: imageResp.response.id
              });
          } catch (error) {
              console.error("File upload failed:", error);
              throw error;
          }
      }

      return {
          type: "file",
          upload_type: "multiple",
          files: files
      };
  }


  onSubmit(e) {
    e.preventDefault();
    const valid = this.validateForm();
    if (valid) {
      this.submitBtn?.classList.add('loading');
      void this.getForm().catch((err) => {
        console.error('getForm rejected:', err);
        this.submitBtn?.classList.remove('loading');
      });
    }
  }
}

customElements.define('custom-form', customForm);

/**
 * Description content toggle functionality
 */
// Check if the custom element 'description-toggle' is not already registered
if (!customElements.get('description-toggle')) {
  // Define a new custom element called 'description-toggle'
  class descriptionToggle extends HTMLElement {
    constructor() {
      super();

        this.readMoreTrigger = this.querySelectorAll('[data-read-more-trigger]');
        
  // If elements with '[data-read-more-trigger]' attribute are found
  if (this.readMoreTrigger.length > 0) {
    // Iterate through each element found
    this.readMoreTrigger.forEach(action => {
      // Add a click event listener to each element
      action.addEventListener('click', (e) => {
        e.preventDefault();
        // Find the closest ancestor element with the attribute '[data-description]'
        let parentEle = e.currentTarget.closest('[data-description]');
        // Check if the clicked element triggers 'read-more' or 'read-less'
        let shortDescEle = parentEle.querySelector('[data-short-desc]');
        let fullDescEle = parentEle.querySelector('[data-full-desc]');

        Utility.slideToggle(fullDescEle,250);
        Utility.slideToggle(shortDescEle,250);
      })
    })
  }

  }
}
// Register the 'description-toggle' custom element
customElements.define('description-toggle', descriptionToggle);
}